// DS: i3.9
import React from 'react';
import IconWrap from '../../IconWrap';
const Upload = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        role: props.role
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16.913 20a1 1 0 110 2h-10a1 1 0 010-2h10zM11.34 1.18a1 1 0 011.147 0l.1.08 8.412 8 .088.09a1 1 0 01-.64 1.643l-.12.007h-3.414v6l-.006.117a1 1 0 01-.877.876l-.117.007h-8l-.116-.007a1 1 0 01-.877-.876L6.913 17v-6H3.5l-.117-.007a1 1 0 01-.64-1.647l.084-.086 8.414-8 .099-.08zm.573 2.172L6.086 9h2.827v7h6V9h2.826l-5.826-5.648z"
    })));
};
Upload.displayName = 'Upload';
export default Upload;
